import React from 'react';

const PageHeader = ({ eyebrow, title, description }) => {
  return (
    <section className="relative bg-slate-900 pt-44 pb-20 md:pt-52 md:pb-24 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-600 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {eyebrow && (
          <span className="inline-block text-blue-400 font-semibold text-sm uppercase tracking-wider mb-4">
            {eyebrow}
          </span>
        )}
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-5 leading-tight">
          {title}
        </h1>
        {description && (
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
